import React from 'react';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import './SocialIcons.css';

const SocialIcons = ({ size = 'medium', className = '' }) => {
  const socialLinks = [
    {
      name: 'GitHub',
      icon: FaGithub,
      url: 'https://github.com/shyamranjan-sr',
      color: '#333333',
      hoverColor: '#000000'
    },
    {
      name: 'LinkedIn',
      icon: FaLinkedin,
      url: 'https://www.linkedin.com/in/shyamranjan-sr',
      color: '#0077B5',
      hoverColor: '#005885'
    },
    // {
    //   name: 'Twitter',
    //   icon: FaTwitter,
    //   url: 'https://twitter.com/shyamranjan_sr',
    //   color: '#1DA1F2',
    //   hoverColor: '#1a91da'
    // },
    {
      name: 'Instagram',
      icon: FaInstagram,
      url: 'https://www.instagram.com/shyamranjan.sr',
      color: '#E4405F',
      hoverColor: '#d13552'
    },
    {
      name: 'Email',
      icon: FaEnvelope,
      url: 'mailto:shyamranjan.sr@outlook.com',
      color: 'gray',
      hoverColor: '#525364ff'
    },
    // {
    //   name: 'WhatsApp',
    //   icon: FaWhatsapp,
    //   url: 'https://wa.me/919801690900',
    //   color: '#25D366',
    //   hoverColor: '#128C7E'
    // }
  ];

  return (
    <div className={`social-icons social-icons--${size} ${className}`}>
      {socialLinks.map((social) => {
        const Icon = social.icon;
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            aria-label={social.name}
            style={{
              '--social-color': social.color,
              '--social-hover-color': social.hoverColor
            }}
          >
            <Icon />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
